module.exports = __webpack_public_path__ + "static/media/simeps.3eaf9d06.svg";